<div class="spinner">
    <nz-spin [nzSpinning]="isSpinning" nzSimple [nzSize]="'large'"></nz-spin>
</div>